import cs from '../locales/cs.json';
import en from '../locales/en.json';
import { getFromLocalStorage } from './LocalStorageUtils';

type Locale = 'cs' | 'en';

const getLocale = (): Locale => {
    const storedLocale = typeof window !== 'undefined'
        ? getFromLocalStorage('inels-locale')
        : null;
    return storedLocale?.toLowerCase().startsWith('cs') ? 'cs' : 'en';
};

const actuatorKeyTranslations: Record<Locale, Record<string, string>> = {
    cs: cs.actuatorKeys,
    en: en.actuatorKeys
};

export const GetNameWithTranslation = (prefix: string, key: string, suffix?: string): string => {
    const locale = getLocale();
    const translated = actuatorKeyTranslations[locale][key] ?? actuatorKeyTranslations.en[key] ?? key;

    return `${prefix} ${translated}${suffix ?? ''}`;
};